import { render, staticRenderFns } from "./ArticlesSelectionSection.vue?vue&type=template&id=0a9ed120&scoped=true"
import script from "./ArticlesSelectionSection.vue?vue&type=script&lang=js"
export * from "./ArticlesSelectionSection.vue?vue&type=script&lang=js"
import style0 from "./ArticlesSelectionSection.vue?vue&type=style&index=0&id=0a9ed120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9ed120",
  null
  
)

export default component.exports